export default "__VITE_ASSET__33191d40__"